module.exports = __webpack_public_path__ + "static/img/web2.de3334f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/develop/soft/web2.jpg
// module id = RJfH
// module chunks = 0